import React from 'react';
import PropTypes from 'prop-types';
import { click } from 'analytics/utilities';

export const withSegmentEvent = ({ eventName, properties }) => (Component) => {
  const SegmentEventComponent = ({ onClick: handleClick, ...props }) => {
    const onClick = () => {
      click(eventName)(properties);
      handleClick();
    };

    return (
      <Component
        {...props}
        onClick={onClick}
      />
    );
  };

  SegmentEventComponent.propTypes = {
    onClick: PropTypes.func
  };

  SegmentEventComponent.defaultProps = {
    onClick: () => {}
  };
  return SegmentEventComponent;
};
